import { Injectable } from '@angular/core';
import { Point } from 'geojson';
import { MapElement } from '../../../shared/map/map-element.model';
import { MapService } from '../../../shared/map/map.service';

@Injectable({
  providedIn: 'root'
})
export class FocusActionService {
  constructor(
    private mapService: MapService,
  ) {

  }

  /**
   * Should have tenant-specific logic
   */
  public setFocus(feature: MapElement<Point>) {
    console.log('SET FOCUS', feature);

    // Set the selected layer visible
    feature.layer.setVisibility(true, true);

    /**
     * Set the marker selected and deselect after click on the map
     */
    this.mapService.changeCurrentFeature(feature);
    this.zoom(feature);
  }

  private zoom(feature: MapElement<Point>) {
    const updatedFeature = feature.layer.getSingleFeature(feature.id);
    const zoomFeature = updatedFeature?.geometry.type === 'Point'
                          ? <MapElement<Point>>updatedFeature
                          : feature;
    this.mapService.flyTo({
      lat: zoomFeature.geometry.coordinates[1],
      lng: zoomFeature.geometry.coordinates[0]
    }, zoomFeature.layer.metadata.zoomLevel
        ? zoomFeature.layer.metadata.zoomLevel
        : this.mapService.getZoom());
  }

}
